import { Button, Card, CardContent, Typography } from "@mui/material";
import withRouter from "hoc/withRouter";
import { useGetChannelConnections } from "hooks/useGetChannelConnections";
import { FaCircle, FaInstagram, FaTelegram, FaWhatsapp } from "react-icons/fa";
import { toast } from "react-toastify";
import ChannelConnectionsAdminService from "services/admin/channelConnections";
import { Link, useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { CHANNEL_STATUS } from "../Whatsapp/WhatsappConnect";
import { MdAdd } from "react-icons/md";

const channels = [
  {
    name: "WHATSAPP",
    icon: <FaWhatsapp />,
    disabled: false,
  },
  {
    name: "TELEGRAM",
    icon: <FaTelegram />,
    disabled: true,
  },
  {
    name: "INSTAGRAM",
    icon: <FaInstagram />,
    disabled: true,
  },
  {
    name: "TEST_SANDBOX",
    icon: <MdAdd />,
    disabled: false,
  },
];
/**
 * Страница для настройки интеграций агента
 * Список доступных интеграций:
 * - WhatsApp
 * - Telegram
 * - Instagram
 * @returns
 */
const AgentChannels = ({
  router: {
    params: { id },
  },
}: any) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { data: channelConnections } = useGetChannelConnections({
    agentID: id,
  });

  const channelConnectionsMap = new Map<string, any>(
    channelConnections?.map((connection: any) => [connection.source, connection])
  );

  console.log("channelConnections: ", channelConnectionsMap);

  const handleConnect = async (source: string) => {
    console.log(`Подключение к ${source}`);
    const { data: created } = await ChannelConnectionsAdminService.post({
      agentID: id,
      source: source,
    });
    navigate(`/admin/ai-agents/${id}/channels/${created.id}`);
  };

  return (
    <div>
      <div className="mb-16">
        <h3 className="mb-2">Каналы</h3>
        <p>
          Канал — это источник или точка коммуникации, откуда приходят сообщения пользователей и
          куда агент может отправлять ответы.
        </p>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-16">
        {channels.map((channel) => (
          <Card key={channel.name}>
            <CardContent>
              <div className="flex justify-center items-center w-full h-full mb-4">
                <div className="flex justify-center items-center mr-2 text-2xl">{channel.icon}</div>
                <Typography variant="body1">{channel.name}</Typography>
                {channelConnectionsMap.has(channel.name) ? (
                  channelConnectionsMap.get(channel.name)?.status === CHANNEL_STATUS.ACTIVE ? (
                    <FaCircle className="text-green-500 ml-2" size={12} />
                  ) : (
                    <FaCircle className="text-orange-500 ml-2" size={12} />
                  )
                ) : null}
              </div>
              {channelConnectionsMap.has(channel.name) ? (
                <Button
                  fullWidth
                  className="cursor-pointer color-blue"
                  onClick={() =>
                    navigate(
                      `/admin/ai-agents/${id}/channels/${
                        channelConnectionsMap.get(channel.name)?.id
                      }`
                    )
                  }
                >
                  <Typography variant="body1">Детали</Typography>
                </Button>
              ) : (
                <Button
                  fullWidth
                  variant="text"
                  color="primary"
                  onClick={() => handleConnect(channel.name)}
                >
                  Подключить
                </Button>
              )}
            </CardContent>
          </Card>
        ))}
      </div>
    </div>
  );
};

export default withRouter(AgentChannels);
